<template>
  <div v-if="data">
    <div class="container">
      <div class="row">
        <div class="col-sm">
          <button type="button" class="btn btn-link btn-l" @click="$router.go(-1)">
            &#8592;
          </button>
        </div>
        <div class="col-sm">
          <h4 v-html="data.testResultLogin.testResultsHeader"></h4>
        </div>
        <div class="col-sm">
          <!-- <button type="button" class="btn btn-link btn-r"
            :disabled="!isSsnValid" @click="$router.push('/login-ec')">
            &#8594;
          </button> -->
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-4 card">
          <h6 class="text-primary" v-html="data.ssn.ssnHeader"></h6>
          <div class="phone-number-wrapper">
            <label class="text-small" for="ssn" v-html="data.testResultLogin.personalNumberLabel"></label>
            <input
              class="form-control form-control-lg ssn-input"
              type="number" name="ssn"
              autocomplete="nope"
              autocapitalize="none"
              ref="ssn"
              :placeholder="data.ssn.ssnTempFormatLabel"
              v-model="ssn"
              @keyup.enter="enterKeyHandler()"
              @input="showHelp = true"
            />
            <small class="text-muted" v-if="showHelp" v-html="data.misc.formatHelper"></small>
            <div class="clearfix"></div>
            <small class="text-small" v-html="data.testResultLogin.testResultsLoginText"></small>
            <div class="clearfix"></div>
            <button
              class="btn btn-primary btn-lg btn-block"
              @click="tokenStart()"
              :disabled="!isSsnValid" v-html="data.misc.nextBtn">
            </button>
            <div class="clearfix"></div>
            <alert v-show="alert" v-html="data.error.errorHeader"></alert>
          </div>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-sm"></div>
        <div class="col-sm"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Alert from '../../src/components/Alert'
import { debounce } from '../plugins/debounce'
import { request } from '../plugins/datocms'
import { luhnSsn } from '../plugins/luhnssn'

export default {
  name: 'loginconfirm',
  components: {
    Alert
  },
  data () {
    return {
      language: sessionStorage.getItem('language'),
      ssn: null,
      showHelp: false,
      data: null,
      alert: false
    }
  },
  computed: {
    isSsnValid () {
      return luhnSsn(this.ssn)
    }
  },
  methods: {
    enterKeyHandler () {
      if (this.isSsnValid) {
        this.tokenStart()
      }
    },
    tokenStart () {
      sessionStorage.setItem('ssn', this.ssn)
      sessionStorage.setItem('phoneNumberConfirmed', true)
      this.$router.push('login-ec')
    }
  },
  watch: {
    ssn: debounce(function () {
      this.showHelp = false
    }, 1000)
  },
  created () {
    window.addEventListener('keydown', this.enterKeyHandler)
  },
  destroyed () {
    window.removeEventListener('keydown', this.enterKeyHandler)
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          testResultLogin(locale: ` + sessionStorage.getItem('language') + `) {
            testResultsHeader
            personalNumberLabel
            testResultsText
            testResultsLoginText
          }
          ssn(locale: ` + sessionStorage.getItem('language') + `) {
            ssnTempFormatLabel
            ssnHeader
          }
          misc(locale: ` + sessionStorage.getItem('language') + `) {
            nextBtn
            formatHelper
          }
          error(locale: ` + sessionStorage.getItem('language') + `) {
            errorHeader
          }
        }
      `
    })
    setTimeout(() => { window.scrollTo(0, 0) })
    this.$nextTick(() => this.$refs.ssn.focus())
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}
#alert {
  display: none;
}
.container {
  padding-bottom: 6vh;
}
.card {
  min-height: 500px;
}
.margin-top-25 {
  margin-top: 25px;
}
.text-small {
  font-size: 16px;
}
.text-muted {
  font-size: 12px;
}
.phone-number-wrapper {
  display: inline-block;
  position: relative;
  font-size: 26px;
  width: 100%;
}
.ssn-input, .phone-number-input {
  text-align: center;
}
.phone-number-input:disabled {
  border: 0;
  background: transparent;
}
button:disabled {
  opacity: 0.3;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .container {
    margin-top: 8vh;
    margin-bottom: -7.5vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login_Confirm.vue